type SupporterReturnDispatchStatus = "handled" | "unhandled" | "rejected";

export function dispatchSupporterReturnOnce(
  readState: { current: boolean },
  dispatch: () => SupporterReturnDispatchStatus,
): boolean {
  if (readState.current) return false;
  if (dispatch() !== "handled") return false;
  readState.current = true;
  return true;
}
